import { render, staticRenderFns } from "./teacherLeaveClassForm.vue?vue&type=template&id=9cfd24be&scoped=true&"
import script from "./teacherLeaveClassForm.vue?vue&type=script&lang=js&"
export * from "./teacherLeaveClassForm.vue?vue&type=script&lang=js&"
import style0 from "./teacherLeaveClassForm.vue?vue&type=style&index=0&id=9cfd24be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfd24be",
  null
  
)

export default component.exports